export default class filterCreativecorner {
    /*
     * Fires first
     */
    constructor() {
        // Add events
        this.addEvents();
    }

    /*
     * Add events
     */
    addEvents(){
        // Toggle filter mobile
        $('.js-cc-toggle-mobile-filter').on('click', e => {
            e.preventDefault();
            $('#main').toggleClass('relative')
            $('.js-cc-filter').toggleClass('block fixed top-0 left-0 right-0 z-20 max-w-xs md:max-w-lg mx-auto mt-40 max-h-[500px] overflow-y-scroll');
            // $('.js-cc-filter').css('transform', 'translate(-50%, -50%)')
            $('.js-cc-filter, .js-cc-mobile-filter-background').toggle();
        });

        // Clear filter
        $('.js-cc-filter__clear').on('click', e => {
            e.preventDefault();
            $('.js-cc-filter__clear').find('img').toggleClass('rotate-360');

            $('.js-cc-filter__input').each(function(){
                if ($(this).is(':checked')) { 
                        $(this).click();    
                   } 
            });
        });

        $(document).on('click', '.js-cc-filter__input', e => {
          //  $('.js-cc-filter__input').prop('checked', false);

         //   $(e.currentTarget).prop('checked', true)
        });

        // Change posts layout in list
        $(document).on('click', '.js-cc-list-order', e => {
            $('.js-cc-list-order').addClass('!bg-blue-light js-cc-list-style--active');
            $('.js-cc-grid-order').removeClass('!bg-blue-light js-cc-list-style--active');

            $('.js-cc-list-post').removeClass('grid');
            $('.js-cc-list-post').addClass('space-y-12');

            $('.js-cc-single-post').addClass('space-x-4');
            $('.js-cc-single-post').removeClass('flex-col');

            // $('.js-cc-post-btn').removeClass('absolute');
        });

        // Change posts layout in grid
        $(document).on('click', '.js-cc-grid-order', e => {
            $('.js-cc-grid-order').addClass('!bg-blue-light js-cc-list-style--active');
            $('.js-cc-list-order').removeClass('!bg-blue-light js-cc-list-style--active');

            $('.js-cc-list-post').removeClass('space-y-12');
            $('.js-cc-list-post').addClass('grid');

            $('.js-cc-single-post').addClass('flex-col');
            $('.js-cc-single-post').removeClass('space-x-4');

            // $('.js-cc-post-btn').addClass('absolute');
        });

        // Run Ajax call when change order
        $(document).on('change', '.js-cc-sort-order' , e => {
            $('.js-cc-sort-order').val( $(e.currentTarget).val() );
            this.ajaxCall($(e.currentTarget));
        });

        // Run Ajax call when click some filter or pagination
        $(document).on('click', '.js-cc-filter__input, .js-cc-prev-page, .js-cc-next-page, .js-cc-clear-filters', e => {
            this.ajaxCall($(e.currentTarget));
        });

        $(document).on('click', '.js-mobile-toggle-filter', e => {
            if( $( document ).width() <= 1280 ){
                $(e.currentTarget).next('.js-cc-filter__category-box').slideToggle();
                $(e.currentTarget).find('.js-cc-filter__icon-accordion').toggleClass('rotate-180');
            }
        });
    }

    // Ajax call to get posts, pagination and posts counter
    ajaxCall( $currentElement ){
        let inputsTerms = this.getInputsValues();
        let currentPage = $('.js-cc-current-page').first().text();
        let layoutStyleClasses = ( $('.js-cc-list-style--active').first().hasClass('js-cc-list-order') === true) ? 'grid grid-cols-6 grid-flow-col gap-4' : '';
        let order = 'newest'

        //Calculate pagination
        if( $currentElement.hasClass('js-cc-next-page') ) {
            currentPage = parseInt(currentPage) + 1
        } else if( $currentElement.hasClass('js-cc-prev-page') ) {
            currentPage = parseInt(currentPage) - 1
        } else {
            currentPage = 1
        }

        // Check order
        if( $currentElement.hasClass('js-cc-sort-order') ) {
            order = $currentElement.val();
        }

        $.ajax({
            type: 'GET',
            url: ajaxObject.ajax_url,
            dataType: 'json',
            data: {
                action: 'filterCreativecorner',
                inputsTerms: inputsTerms,
                currentPage: currentPage,
                order: order,
            },
            beforeSend: () => {
                $('.js-cc-wrap-posts').addClass('opacity-40', 'pointer-events-none');
            },
            success: (result) => {
                $('.js-cc-list-post').empty();
                $('.js-listing-actionbar__pagination').html( result.data.pagination );
                $('.js-listing-actionbar__results').html( result.data.posts_counter );
                $('.js-cc-wrap-posts').removeClass('opacity-40', 'pointer-events-none');

                let posts = result.data.posts;

                posts.forEach(element => {
                    // let excerpt = '';
                    let satelliteClass = '';
                    let satelliteCat = '';

                    if( element.postType !== 'post' ) {
                        satelliteClass = 'js-satellite--click-download';

                        if( element.category ) {
                            satelliteCat = 'data-st-download-cat="' + element.category.replace(/(<([^>]+)>)/gi, '') + '"';
                        }
                    }

                    // excerpt = '<p class="mb-3 lg:pb-12">' + element.excerpt + '</p>';

                    let post= '<article class="flex flex-col relative // js-cc-single-post h-full' + layoutStyleClasses + '">' +
                        '<img loading="lazy" src="' + element.image + '" alt="' + element.alt + '" class="mb-3">' +

                        '<div class="flex flex-col flex-auto">' +
                            '<p class="text-sm mb-3">' + element.category + '</p>' +

                            '<h3 class="break-words mb-3">' +
                                '<a href="' + element.url + '" class="text-gray">' + element.title + '</a>' +
                            '</h3>' +

                            '<p class="lg:mb-12">' + element.excerpt + '</p>' +

                            '<a href="' + element.url + '" ' + satelliteCat + ' class="btn-no-bg mt-auto self-start // js-cc-post-btn ' + satelliteClass + '" target="_blank">' + element.label + '</a>' +
                        '</div>' +
                    '</article>';

                    $('.js-cc-list-post').append(post);
                });

                // scroll on the top of page when results are ready on the page
                $('html, body').animate({
                    scrollTop: ($('.js-cc-wrap-posts').offset().top - 200),
                },500);

                // Satellite
                let idChecked = $( ".js-cc-filter__input:checked" ).attr('id')
                let filter_category = $('label[for="' + idChecked + '"]').html()
                let form_values = {
                    'name' : idChecked,
                    'value' : filter_category,
                }

                let filter_interaction = 'added';

                if ( filter_category === 'All'){
                    filter_interaction = 'cleared'
                }

                console.log({
                    filter_info: form_values,
                    filter_interaction: filter_interaction,
                    results_total: result.data.satellite_result_amount,
                });

                _satellite.track("filter_interaction", {
                    filter_info: form_values,
                    filter_interaction: filter_interaction,
                    results_total: result.data.satellite_result_amount,
                });
            },
        });
    }

    // Get all inputs value
    getInputsValues() {
        var taxonomies = new Object();

        //Collect taxonomies and set it as key
        $('.js-cc-filter__input').each((index, element) => {
            if( $(element).prop("checked") == true){
                let taxonomyKey = $(element).attr('name');
                taxonomies[taxonomyKey] = [];
            }
        });

        // Push terms
        $('.js-cc-filter__input').each((index, element) => {
            if( $(element).prop("checked") == true) {
                let taxonomy = $(element).attr('name')
                let term = $(element).val()
                taxonomies[taxonomy].push(term)
            }
        });

        return taxonomies;
    }
}